import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';
import styled from 'styled-components';

export const DatePicker = styled(generatePicker(dayjsGenerateConfig))`
  border-width: 0;
  font-weight: 500;
  width: 100%;
  border-radius: 0.8em;

  .ant-picker-input {
    border-radius: 0.4em;
    transition: all 300ms;

    input {
      display: inline-block;
      padding-left: 0.16em;
      font-size: 30px;
      text-align: left;
      font-weight: 500;
    }
  }
`;
